// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-css/semantic.min.css
// module id = 602
// module chunks = 170